// b76dff1dffdd73059d690f98d75e9d8dca1de0b6|name=UserMemoryBlockUpdate|schemaHash=e95982080543cdba1717d3fb67eb8c5f6a84bfc5|kind=parser-js

import { setDefinedValue } from '@myre/common-primitives';

export function parseUserMemoryBlockUpdateFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'content', _data.content);

  return result;
}

export function parseUserMemoryBlockUpdateToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'content', _data.content);

  return result;
}
